import { Users } from 'lucide-react';
import { useEffect, useState } from 'react';

import { API_URL } from '../../config/api'
interface Member { id: number; user_id: number; display_name: string; role: string; joined_at: string }
interface ProjectMembersProps { projectId: number }

export default function ProjectMembers({ projectId }: ProjectMembersProps) {
  const [members, setMembers] = useState<Member[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await fetch(`${API_URL}/api/projects/${projectId}/members`)
        const data = await res.json()
        const mems = data.members as Member[]
        setMembers(mems || [])
      } catch (err) {
        console.error('Members load error:', err)
      } finally {
        setLoading(false)
      }
    }
    void loadMembers()
  }, [projectId])

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Users size={24} /> Members ({members.length})
      </h2>
      {members.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <Users size={64} style={{ opacity: 0.5, marginBottom: '16px' }} />
          <h3>No members yet</h3>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
          {members.map(member => (
            <div key={member.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'linear-gradient(135deg, #667eea, #764ba2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '700', fontSize: '18px' }}>
                {member.display_name.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', color: '#1a202c', marginBottom: '4px' }}>{member.display_name}</div>
                <div style={{ fontSize: '13px', color: '#94a3b8' }}>{member.role}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
